
import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'
import PropertyMultiselect from '@/components/PropertyMultiselect.vue'

export default Vue.extend({
  components: {
    PropertyMultiselect
  },

  data: () => ({
    heatingTypes: [
      {
        name: 'Padlófűtés',
        help: 'Válassza ki a padlófűtéssel fűteni kívánt helyiségeket!',
        key: 'floor'
      },
      {
        name: 'Vakolatos felületfűtés/hűtés',
        help: 'Válassza ki a PPS-10 vakolatos rendszerrel fűteni/hűteni kívánt helyiségeket!',
        key: 'plaster'
      },
      {
        name: 'Gipszkartonos felületfűtés/hűtés',
        help: 'Válassza ki a GBP-10 gipszkartonos rendszerrel fűteni/hűteni kívánt helyiségeket!',
        key: 'board'
      },
      {
        name: ' Álmennyezeti fémpaneles (CDP-400) felületfűtés/hűtés',
        help: 'Válassza ki a CDP-400 lemezes rendszerrel fűteni/hűteni kívánt helyiségeket!',
        key: 'cdp400'
      },
      {
        name: 'Monolit betonfödém (SLAB-16) felületfűtés/hűtés',
        help: 'Válassza ki a SLAB-16 födémfűtés-hűtés rendszerrel fűteni/hűteni kívánt helyiségeket!',
        key: 'slab16'
      }
    ]
  }),

  methods: {
    selectionChanged (selected: any, type: string) {//eslint-disable-line
      this.$store.commit('setRoomProperty', { selected, type })
    }
  },

  computed: {
    ...mapFields([
      'roomsData'
    ])
  }
})
